import { useQuery } from '@tanstack/react-query';
import { makeGetAllUsers } from 'main/factories/usecases/user';

export const useGetAllUsersByLocation = (locationId: string | undefined) => {
  return useQuery({
    queryKey: ['allUsers', locationId],
    queryFn: async () => {
      const service = makeGetAllUsers();
      const result = await service.getAllUsers({ locationId });
      return result instanceof Error ? [] : result;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!localStorage.getItem('hone:session'),
  });
};
